import React from "react";
import { node } from "prop-types";
import { Col, Row } from "../Grid";

export const CardBlockRow = ({ children, ...props }) => (
	<Row mx my spacing={{ mt: 2 }} {...props}>
		{children}
	</Row>
);

CardBlockRow.propTypes = {
	children: node.isRequired,
};
export const CardBlockCol = ({ children, ...props }) => (
	<Col md={6} lg={3} spacing={{ sm: { mb: 8 }, md: { mb: 4 } }} {...props}>
		{children}
	</Col>
);

CardBlockCol.propTypes = {
	children: node.isRequired,
};
